import { render } from "./noShare.vue?vue&type=template&id=1f658774&scoped=true"
import script from "./noShare.vue?vue&type=script&lang=js"
export * from "./noShare.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1f658774"

export default script